<template>
  <div class="operations">
    <div class="label"><i class="fas fa-calculator"></i> {{ getLang('operation') }}</div>
    <div class="radio-wrapper">
      <p-radio v-for="(operation) in operations" :key="element.id + '-' + operation.key"
        :name="'operation-' + element.id"
        :class="['p-radio', 'curve', 'p-smooth', 'p-bigger', operation.key]"
        color="primary"
        :value="operation.key"
        v-model="element.operation.operationValue"
        v-tooltip.top="{content: operation.description, delay: { show: 200, hide: 200 }}"
      >
        {{ operation.name }}
        <div :class="['operation-info', operation.key]">
          <i class="sherpa-icon icon-question info"></i>
        </div>
      </p-radio>
    </div>
  </div>
</template>

<script>
import PrettyRadio from '@/components/shared/PrettyRadio.vue'

export default {
  name: 'operation-value',
  components: {
    PrettyRadio
  },
  props: {
    element: Object,
    operations: Array,
    container: String,
    getLang: Function
  },
  data () {
    return {
    }
  },
  methods: {
  },
  beforeMount () {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
.operations {
}
</style>
